import { MODAL_AUTH } from '@components/App/Modal/constants'
import { UserMenu } from '@components/UserMenu'
import { Tooltip } from '@lib/components'
import { Button } from '@octopus-do/octopus-storybook'
import { User as UserIcon } from '@octopus-do/octopus-storybook/icons'
import { openModal } from '@storeOld/reducers/ui'
import type React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import type { AppState } from '@/types'

export const AccountMenu: React.FC = () => {
  const dispatch = useDispatch()

  const authenticated = useSelector<AppState, boolean>(
    ({ auth }) => auth.authenticated
  )

  const onClickAvatar = () => {
    dispatch(openModal(MODAL_AUTH))
  }

  if (!authenticated) {
    return (
      <Tooltip content="Profile" wrap={false}>
        <Button
          priority="secondary"
          size="medium"
          left={UserIcon}
          aria-label="Profile"
          data-testid="profile"
          onClick={onClickAvatar}
        />
      </Tooltip>
    )
  }

  return <UserMenu />
}
